// extracted by mini-css-extract-plugin
module.exports = {"crossOperatorAmount":"_3262a85","crossOperatorError":"_5d3d19e"};